import { RefundProvider } from '../../store/RefundProvider';
import RefundForm from './refund_form';

const NewRefund = () => {
  return (
    <RefundProvider>
      <RefundForm />
    </RefundProvider>
  )
};

export default NewRefund;